import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'
import theme from 'antd/es/theme/index'
import IdeyaTypography from '@/common/antd/ideya-typography.tsx'
import { useAppSelector } from '@/redux/hooks.ts'
import { selectThemeStyle } from '@/features/setting/setting.slice.ts'

const { useToken } = theme

interface IdeaSummaryValueTextProps {
  value: string
  suffix: string
}

export const SummaryValueText: React.FC<IdeaSummaryValueTextProps> = ({
  value,
  suffix,
}) => {
  const { token } = useToken()
  const themeStyle = useAppSelector(selectThemeStyle)

  return (
    <div>
      <Row align={'bottom'} style={{ gap: themeStyle.marginXXS }}>
        <Col>
          <IdeyaTypography.Title level={3} style={{ marginBottom: 0 }}>
            {value}
          </IdeyaTypography.Title>
        </Col>
        <Col>
          <IdeyaTypography.Text
            type={'secondary'}
            size={'lg'}
            style={{ color: token.colorTextTertiary }}
          >
            {suffix}
          </IdeyaTypography.Text>
        </Col>
      </Row>
    </div>
  )
}
